import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { Phone } from "lucide-react";
import { CONTACT } from "../data/content";

export const FloatingCall = () => (
  <a
    href={CONTACT.phoneHref}
    data-testid="floating-call-button"
    aria-label="Anrufen"
    className="lg:hidden fixed bottom-5 left-5 z-40 w-14 h-14 max-[380px]:w-12 max-[380px]:h-12 rounded-full bg-gold text-white flex items-center justify-center shadow-[0_12px_32px_-8px_rgba(110,86,54,0.5)] transition-colors duration-300 active:bg-golddark"
  >
    <Phone size={22} />
  </a>
);

export const CustomCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [hovering, setHovering] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const ringX = useSpring(x, { stiffness: 380, damping: 32, mass: 0.5 });
  const ringY = useSpring(y, { stiffness: 380, damping: 32, mass: 0.5 });

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    setEnabled(true);
    document.body.classList.add("custom-cursor");
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => setHovering(!!e.target.closest("a, button, [role='button'], select, input, textarea, label"));
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    return () => {
      document.body.classList.remove("custom-cursor");
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        aria-hidden="true"
        data-testid="cursor-dot"
        className="fixed top-0 left-0 z-[200] pointer-events-none w-1.5 h-1.5 bg-navy rounded-full"
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
      />
      <motion.div
        aria-hidden="true"
        data-testid="cursor-ring"
        className="fixed top-0 left-0 z-[200] pointer-events-none rounded-full border border-navy/40"
        style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }}
        animate={{ width: hovering ? 48 : 28, height: hovering ? 48 : 28, opacity: hovering ? 0.9 : 0.5 }}
        transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      />
    </>
  );
};
